export default __webpack_public_path__ + "static/step5-f2ae1495b55fc0927be43bc002434baa.svg";